import React, {PropsWithChildren} from 'react';
import * as Sentry from '@sentry/browser';
import {GeneralError} from './GeneralError';
import {ErrorBoundary as ReactErrorBoundary} from 'react-error-boundary';

export const ErrorBoundary: React.FC<PropsWithChildren> = ({children}) => (
  <ReactErrorBoundary
    fallback={<GeneralError />}
    onError={(error, errorInfo) => {
      Sentry.configureScope(scope => {
        Object.keys(errorInfo).forEach(key => {
          scope.setExtra(key, errorInfo[key]);
        });
      });
      Sentry.captureException(error);
    }}
  >
    {children}
  </ReactErrorBoundary>
);
